<div class="modal">
  <div class="close-link">
    <span class="close" [mat-dialog-close]></span>
  </div>
  <h1 class="modal__title">{{ 'pages.restaurantAccount.addIntegrationTitle' | translate }}</h1>

  <form class="modal__form" [formGroup]="addIntegration" (ngSubmit)="addNewIntegration()">
    <mat-form-field floatLabel="always" class="login-wrap__text">
      <mat-label>{{ 'pages.restaurantAccount.provider' | translate }}</mat-label>
      <mat-select placeholder="Choose provider" formControlName="provider">
        <mat-option value="VAST">VAST</mat-option>
        <mat-option value="vistarMedia">Vistar Media</mat-option>
        <mat-option value="kelseysMenu">Kelseys Menu</mat-option>
        <mat-option value="bostonPizzaUI">Boston Pizza UI</mat-option>
        <mat-option value="bostonPizzaEventsAPI">Boston Pizza Events API</mat-option>
        <mat-option value="foyr">Foyr</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="proxy__wrapper" *ngIf="addIntegration.get('proxy')">
      <mat-slide-toggle formControlName="proxy" color="primary">
        {{ 'pages.restaurantAccount.proxy' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle formControlName="proxyUnifiedMode" color="primary">
        {{ 'pages.restaurantAccount.unified' | translate }}
      </mat-slide-toggle>
    </div>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'VAST'">
      <app-integration-vast-form [formGroup]="credentialsFormGroup"></app-integration-vast-form>
    </ng-container>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'vistarMedia'">
      <app-integration-vistar-form [formGroup]="credentialsFormGroup"></app-integration-vistar-form>
    </ng-container>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'kelseysMenu'">
      <app-integration-kelseys-menu-form [formGroup]="credentialsFormGroup"></app-integration-kelseys-menu-form>
    </ng-container>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'bostonPizzaUI'">
      <app-integration-bp-ui-form [formGroup]="credentialsFormGroup"></app-integration-bp-ui-form>
    </ng-container>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'bostonPizzaEventsAPI'">
      <app-integration-bp-events-api-form [formGroup]="credentialsFormGroup"></app-integration-bp-events-api-form>
    </ng-container>

    <ng-container [formGroup]="credentialsFormGroup" *ngIf="addIntegration.get('provider')?.value === 'foyr'">
      <app-integration-foyr-form [formGroup]="credentialsFormGroup"></app-integration-foyr-form>
    </ng-container>

    <div class="modal__submit-btn">
      <button class="btn btn__primary" [disabled]="loading || addIntegration.invalid" type="submit">
        {{ 'pages.restaurantAccount.addIntegration' | translate }}
      </button>
    </div>
  </form>
</div>
